import Pagination from '@mui/material/Pagination';
import Header from 'components/layouts/Header';
import Menu from 'components/layouts/Menu';
import config from 'config';
import { useEffect, useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { IoIosAddCircle } from 'react-icons/io';
import { TiTick } from 'react-icons/ti';
import { useAppDispatch } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import gather from 'tools/gather';

const Operators = () => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countPage, setCountPage] = useState(1);

  const changeActive = async (e: any) => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/operator/${e._id}`, true).put({
      ...e,
      isActive: !e.isActive,
    });

    if (result.code === 200) {
      dispatch(successAlert('Done!'));
      init();
    } else {
      dispatch(errorAlert(result.message));
    }

    dispatch(hideLoading());
  };

  const list = () => {
    const rows: React.ReactElement[] = [];

    data.forEach((e: any, i: number) => {
      rows.push(
        <tr key={i}>
          <td>
            {e.email} - {e.telegram}
          </td>
          <td>{e.isSuperAdmin.toString()}</td>
          <td className='setting'>
            <span>
              <FaEye />
            </span>
            <span className={e.isActive ? 'active' : ''} onClick={() => changeActive(e)}>
              <TiTick />
            </span>
          </td>
        </tr>,
      );
    });

    return rows;
  };

  const init = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/operator?page=${currentPage}&limit=50`, true).get();
    if (result.code === 200) {
      setData(result.data.items.data);
      setCurrentPage(result.data.pages.current);
      setCountPage(result.data.pages.count);
    } else {
      dispatch(errorAlert(result.message));
    }

    dispatch(hideLoading());
  };

  useEffect(() => {
    init();
  }, [currentPage]);

  return (
    <>
      <Menu />
      <div className='container'>
        <Header />
        <div className='topButtons'>
          <span>
            <IoIosAddCircle /> Add
          </span>
        </div>
        <table className='tableData'>
          <tbody>
            <tr>
              <td>Email</td>
              <td>Super Admin</td>
              <td>Setting</td>
            </tr>
            {list()}
          </tbody>
        </table>
        <Pagination count={countPage} color='primary' onChange={(_e, v) => setCurrentPage(v)} />
      </div>
    </>
  );
};

export default Operators;
